import { Injectable } from "@angular/core";
import { STORAGE } from "src/config/storage.config";

type PaginationState = {
  contentId: string;
  contentPartId: string;
  tabindex: string;
  page: number;
};

@Injectable({
  providedIn: "root",
})
export class PaginationStateService {
  private state: PaginationState[];

  public constructor() {
    const value = sessionStorage.getItem(STORAGE.PAGINATION_STATE);
    try {
      if (!value) throw new Error();
      const base = atob(value);
      const json = JSON.parse(base);
      if (this._isPaginationStateArray(json)) {
        this.state = json;
      } else {
        throw new Error();
      }
    } catch (error) {
      this.state = [];
    }
  }

  public set(state: PaginationState): void {
    let _state = [...this.state];
    _state = _state.filter((x) => !(x.contentId === state.contentId && x.contentPartId === state.contentPartId && x.tabindex === state.tabindex));
    if (state.page !== 1) {
      _state = [..._state, state];
    }

    this._update(_state);
  }

  public get(contentId: string, contentPartId: string, tabindex: string): PaginationState | null {
    return this.state.find((s) => s.contentId === contentId && s.contentPartId === contentPartId && s.tabindex === tabindex) || null;
  }

  private _update(state: PaginationState[]): void {
    this.state = state;
    sessionStorage.setItem(STORAGE.PAGINATION_STATE, btoa(JSON.stringify(state)));
  }

  private _isPaginationStateArray(obj: unknown): obj is PaginationState[] {
    return Array.isArray(obj) && obj.every((v) => this._isPaginationState(v));
  }

  private _isPaginationState(obj: unknown): obj is PaginationState {
    return obj !== null && typeof obj === "object" && "contentId" in obj && "contentPartId" in obj && "tabindex" in obj && "page" in obj;
  }
}
